import React from 'react'
import './Events.css';
export default function Events() {
  return (
    <div className="bg3 text-center">
      <div className="container">
        <p className='p p1 shadow-lg'><div className='event-flex'><h1>Sparrow Day</h1><img className='image1'src='https://res.cloudinary.com/dluyslfrm/image/upload/v1683468098/7-05-2023_dvygkf.jpg'></img></div></p>
        <p className='p p1 shadow-lg'><div className='event-flex'><h1>Earth Day</h1><img className='image1' src='https://res.cloudinary.com/di1jyuoqd/image/upload/v1683485585/earth_dayy_wm7k8i.jpg'></img></div></p>
        <p className='p p1 shadow-lg'><div className='event-flex'><h1>Tarumitra</h1><img className='image1' src='https://res.cloudinary.com/dluyslfrm/image/upload/v1683468430/WhatsApp_Image_2023-04-01_at_22.14.18_tkuvj5.jpg'></img></div></p>
        {/* <p className='p p2'>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Veritatis atque voluptatum minima optio libero nobis consectetur dolorum. Perferendis at, dicta quia nihil repellendus tempore reprehenderit expedita, dolore exercitationem sequi mollitia.</p>
        <p className='p p2'>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Veritatis atque voluptatum minima optio libero nobis consectetur dolorum. Perferendis at, dicta quia nihil repellendus tempore reprehenderit expedita, dolore exercitationem sequi mollitia.</p> */}
     </div>

    </div>


  )
}
